import Component from 'flarum/common/Component';
import StoreItemUtils from '../utils/StoreItemUtils';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import setRouteWithForcedRefresh from 'flarum/common/utils/setRouteWithForcedRefresh';
import CreateItemModal from '../components/CreateItemModal';
import { showIf } from "../utils/NodeUtil";
import { effectLengthFormat } from '../utils/TimeUtils';
export default class StoreItemComponent extends Component {
  loading = false;
  isConfirm = false;
  view(vnode) {
    const item = this.attrs.item;
    let tipKey = 'xypp-store.forum.purchase';
    if (item.unavailable()) {
      tipKey = item.unavailable() || "";
      if (tipKey.split(".").length <= 2) tipKey = 'xypp-store.forum.unavailable.' + tipKey;
    } else if (this.isConfirm) {
      tipKey = 'xypp-store.forum.purchase-confirm';
    }
    return m("div", {
      className: "store-item" + (item.valid() ? "" : " invalid")
    }, m("h3", null, item.name()), m("div", {
      class: "store-item-showcase"
    }, m("div", {
      className: "store-item-showcase-tip"
    }, StoreItemUtils.getInstance().getProviderName(item.provider())), StoreItemUtils.getInstance().createItemShowCase(item)), m("div", {
      class: "store-item-description"
    }, item.desc()), m("div", {
      class: "store-item-info"
    }, m("span", {
      className: "store-item-time"
    }, m("i", {
      className: "fas fa-clock fas-space-right"
    }), showIf(!!item.expire_time(), app.translator.trans('xypp-store.forum.item.expire', [effectLengthFormat(item.expire_time())]), app.translator.trans('xypp-store.forum.history.forever'))), m("span", {
      className: ""
    }, m("i", {
      className: "fas fa-cubes fas-space-right"
    }), showIf(!!(item.rest_cnt() !== null), app.translator.trans('xypp-store.forum.item.rest_cnt', [item.rest_cnt()]), app.translator.trans('xypp-store.forum.item.infinity_count'))), m("span", {
      className: ""
    }, showIf(!!item.can_use(), [m("i", {
      className: "fas fa-undo-alt  fas-space-right"
    }), showIf(!!item.use_cnt(), app.translator.trans('xypp-store.forum.item.use_cnt', [item.use_cnt()]), app.translator.trans('xypp-store.forum.history.infinity_use'))]))), m("span", {
      className: "text-separate store-item-bottom"
    }, m(Button, {
      className: item.unavailable() ? 'store-item-button Button' : 'store-item-button Button Button--primary',
      onclick: this.buy.bind(this),
      loading: this.loading,
      disabled: this.loading || item.unavailable()
    }, m("i", {
      class: "fas fa-cart-plus fas-space-right"
    }), m("span", null, app.translator.trans(tipKey)), " | ", m("span", {
      className: "store-item-price"
    }, m("i", {
      class: "fas fa-coins fas-space-right"
    }), item.price() <= 0 ? app.translator.trans('xypp-store.forum.price_free') : item.price()))), this.attrs.noEdit || !app.session.user?.canCreateStoreItem() ? '' : m("div", {
      class: "edit-store-item",
      onclick: this.edit.bind(this)
    }, m("i", {
      class: "fas fa-edit",
      "aria-label": app.translator.trans('xypp-store.forum.edit_button')
    })));
  }
  async buy() {
    if (!this.isConfirm) {
      this.isConfirm = true;
      setTimeout(this.resetConfirm.bind(this), 6000);
      return;
    }
    if (this.attrs.onBuy) {
      this.attrs.onBuy();
      return;
    }
    this.loading = true;
    m.redraw();
    try {
      const purchaseHistoryPayload = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/store-item/' + this.attrs.item.id() + '/purchase'
      });
      const purchaseHistory = app.store.pushPayload(purchaseHistoryPayload);
      app.alerts.show({
        type: "success"
      }, app.translator.trans('xypp-store.forum.purchase_result.success'));
      await StoreItemUtils.getInstance().afterPurchase(purchaseHistory);
      if (this.attrs.onSubmit) {
        app.store.find("store-item", this.attrs.item.id()).then(item => {
          this.attrs.onSubmit(item);
          this.loading = false;
          m.redraw();
        });
        return;
      }
      setRouteWithForcedRefresh(app.route("storePage"));
    } catch (e) {
      console.log(e);
      this.loading = false;
    } finally {
      if (!this.attrs.onSubmit) this.loading = false;
      this.isConfirm = false;
      m.redraw();
    }
  }
  edit() {
    app.modal.show(CreateItemModal, {
      item_id: this.attrs.item.id(),
      onDelete: this.attrs.onDelete,
      onSubmit: this.attrs.onSubmit
    });
    m.redraw();
  }
  resetConfirm() {
    if (this.isConfirm) {
      this.isConfirm = false;
      m.redraw();
    }
  }
}
flarum.reg.add('xypp-store', 'forum/components/StoreItemComponent', StoreItemComponent);